export default "__VITE_ASSET__C4ydpEC___"